<template>
    <div style="border-radius: 10px;">
        <div class='SalesFilterElement RoundShadowElement' style="text-align: center; cursor: pointer;">
            {{ label }}
        </div>
    </div>
</template>
<script>
export default{
    props:{
        label: String,
    }
}
</script>